// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2aKOH","title":"ClientInsurance_title__2Ltis","itemText":"ClientInsurance_itemText__3enfE"};